
//this is where we will place the name and version number associated with all feature toggles related to civics.
define(function(require) {
	return {
		//Name is the IPS representation of the feature toggle name.
		//version first available is the first IPS version that supported the toggle. We use this to determine if a feature is innactive even if it's not
		//	included in the configuration response, as it wouldn't exist in an earlier version of IPS
		AUTHORIZED_USERS:{name:"Hansen.Portal.FeatureToggle.PortalAuthorizedUserFeature", versionFirstAvailable: '8.8.0.2501'}, //TODO: Changed to 2501 version for QA testing, need to change back to 2504 once done.
		SUBMITTAL_FEATURES:{name:"Hansen.Portal.FeatureToggle.PortalSubmittalEnhancementsFeature", versionFirstAvailable: '8.8.0.2510'},
		INVITEE_UX: {name: "Hansen.Portal.FeatureToggle.PortalInviteUserExperience", versionFirstAvailable: '8.8.0.2510'},
		SEPARATE_TRANSLATION_FILES: {name: "Hansen.Portal.FeatureToggle.PortalSeparateTranslationFiles", versionFirstAvailable: '8.8.0.2610'}
	};
});
